var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfCarousel',{staticClass:"product-carousel",attrs:{"settings":{
    animationDuration: 600,
  }}},_vm._l((_vm.products),function(product,i){return _c('SfCarouselItem',{key:i},[_c('ProductGridItem',{staticClass:"products__grid-item",attrs:{"product":product,"is-cart-enabled":false,"show-stock-errors":false,"link-tag":"router-link","link":'/p/' + product.variantId}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }